
// Define the base KanbanCandidate type directly without importing
export interface KanbanCandidate {
	id: string;
	name: string;
	skills: string[];
	score?: number;
	stage: string;
	candidateId: string;
	jobId: string;
	email?: string;
	jobTitle?: string;
	createdAt?: string;
	company?: string;
	position?: string;
	date?: string;
	analysisInProgress?: boolean;
}

export interface KanbanStage {
	id: string;
	name: string;
}

// Define all recruitment stages in order
export const KANBAN_STAGES: KanbanStage[] = [
	{ id: 'matched', name: 'Matched' },
	{ id: 'screening', name: 'Screening' },
	{ id: 'sent', name: 'Sent' },
	{ id: 'interview', name: 'Interview' },
	{ id: 'offer', name: 'Offer' },
	{ id: 'refused', name: 'Refused' }
];
